import {IAutoOrderAccountSettings} from './ao-account-settings.interface';
import {IOpenOrderFilterSettings} from './ao-open-order-filter-settings.interface';
import {IOpenOrderViewSettings} from './ao-open-order-view-settings.interface';

//#region INTERFACE IOpenOrderSettings
export interface IOpenOrderSettings {
  filters: IOpenOrderFilterSettings;
  orderSettings: IOpenOrderViewSettings;
  exportQtyGreaterThanZero?: boolean;
  orderAccountSettings?: IAutoOrderAccountSettings;
  selectedColumns?: string[];
}

//#endregion
